import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
    faHome,
    faQuestion,
    faUser,
    faTimes,
    faTags,
    faPercent,
    faCartArrowDown,
    faMoneyBill,
    faShop,
    faCancel,
    faDatabase,
    faGift,
    faBell,
    faWarehouse,
    faMoneyCheckDollar
} from "@fortawesome/free-solid-svg-icons";
import { Nav, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

import logo_desk from "../../assets/png/navbar_logo_desk.png";

const SideBar = ({ isOpen, toggle }) => {
    return (
        <div className={`sidebar ${isOpen && "is-open"}`}>
            <div className="sidebar-header">
                <Button
                    variant="link"
                    onClick={toggle}
                    style={{ color: "#fff" }}
                    className="mt-4"
                >
                    <FontAwesomeIcon icon={faTimes} pull="right" size="xs" />
                </Button>
                <h3>
                    <Link to={"/"} className="navLogo">
                        {/* <img src={logo_mob} alt="" className="logo_mob" /> */}
                        <img src={logo_desk} alt="" className="logo_deskk" />
                        {/* <img src={logo_tab} alt="" className="logo_tab" /> */}
                    </Link>
                    {/* OlineO Admin Panel */}
                </h3>
            </div>

            <Nav className="flex-column pt-2">
                {/* <p className="ml-3">Dashboard</p> */}

                <Nav.Item
                    className={(isActive) =>
                        "nav-link" + (!isActive ? " active" : "active")
                    }
                    // className="active"
                >
                    <Link className="dash_sidebar_a nav-link" to="/admin">
                        <FontAwesomeIcon icon={faHome} className="mr-2" />
                        Home
                    </Link>
                </Nav.Item>
                {/* <Nav.Item>
                    <Link className="dash_sidebar_a nav-link" to="admin-smart-bandhan">
                        <FontAwesomeIcon icon={faGift} className="mr-2" />
                        Smart Bandhan Offer
                    </Link>
                </Nav.Item>
                <Nav.Item>
                    <Link className="dash_sidebar_a nav-link" to="admin-fourth-anniversary">
                        <FontAwesomeIcon icon={faGift} className="mr-2" />
                       Fourth Anniversary
                    </Link>
                </Nav.Item>
                <Nav.Item>
                    <Link className="dash_sidebar_a nav-link" to="admin-bharat-mahotsav">
                        <FontAwesomeIcon icon={faGift} className="mr-2" />
                        Bharat Mahotsav Offer
                    </Link>
                </Nav.Item> */}
                <Nav.Item>
                    <Link className="dash_sidebar_a nav-link" to="admin-product-comments">
                        <FontAwesomeIcon icon={faGift} className="mr-2" />
                        Product Comments
                    </Link>
                </Nav.Item>
                <Nav.Item>
                    <Link className="dash_sidebar_a nav-link" to="admin-store-comments">
                        <FontAwesomeIcon icon={faGift} className="mr-2" />
                        Store Comments
                    </Link>
                </Nav.Item>
                <Nav.Item>
                    <Link
                        className="dash_sidebar_a nav-link"
                        to="admin-products"
                    >
                        <FontAwesomeIcon icon={faTags} className="mr-2" />
                        Products
                    </Link>
                </Nav.Item>

                <Nav.Item>
                    <Link
                        className="dash_sidebar_a nav-link"
                        to="admin-home-page"
                    >
                        <FontAwesomeIcon icon={faDatabase} className="mr-2" />
                        Home Page
                    </Link>
                </Nav.Item>

                <Nav.Item>
                    <Link className="dash_sidebar_a nav-link" to="admin-orders">
                        <FontAwesomeIcon
                            icon={faCartArrowDown}
                            className="mr-2"
                        />
                        Orders
                    </Link>
                </Nav.Item>

                <Nav.Item className="">
                    <Link
                        className="dash_sidebar_a nav-link"
                        to="admin-discounts"
                    >
                        <FontAwesomeIcon icon={faPercent} className="mr-2" />
                        Coupons
                    </Link>
                </Nav.Item>
                <Nav.Item className="">
                    <Link
                        className="dash_sidebar_a nav-link"
                        to="admin-alluser"
                    >
                        <FontAwesomeIcon icon={faUser} className="mr-2" />
                        All Users
                    </Link>
                </Nav.Item>
                <Nav.Item className="">
                    <Link className="dash_sidebar_a nav-link" to="admin-shops">
                        <FontAwesomeIcon icon={faShop} className="mr-2" />
                        Shops
                    </Link>
                </Nav.Item>

                <Nav.Item>
                    <Link
                        className="dash_sidebar_a nav-link"
                        to="admin-payments"
                    >
                        <FontAwesomeIcon icon={faMoneyBill} className="mr-2" />
                        Payments
                    </Link>
                </Nav.Item>

                <Nav.Item>
                    <Link
                        className="dash_sidebar_a nav-link"
                        to="admin-cancellation"
                    >
                        <FontAwesomeIcon icon={faCancel} className="mr-2" />
                        Cancellation
                    </Link>
                </Nav.Item>

                <Nav.Item>
                    <Link className="dash_sidebar_a nav-link" to="admin-query">
                        <FontAwesomeIcon icon={faQuestion} className="mr-2" />
                        FAQ
                    </Link>
                </Nav.Item>

                <Nav.Item>
                    <Link
                        className="dash_sidebar_a nav-link"
                        to="admin-notifications"
                    >
                        <FontAwesomeIcon icon={faBell} className="mr-2" />
                        Notifications
                    </Link>
                </Nav.Item>
                <Nav.Item>
                    <Link
                        className="dash_sidebar_a nav-link"
                        to="stock-tracker"
                    >
                        <FontAwesomeIcon icon={faWarehouse} className="mr-2" />
                        Stock Tracker
                    </Link>
                </Nav.Item>

                <Nav.Item>
                    <Link
                        className="dash_sidebar_a nav-link"
                        to="refunds"
                    >
                        <FontAwesomeIcon icon={faMoneyCheckDollar} className="mr-2" />
                        Refunds
                    </Link>
                </Nav.Item>

         
                {/* <Nav.Item>
                    <Link className="dash_sidebar_a nav-link" to="admin-offers">
                        <FontAwesomeIcon icon={faGift} className="mr-2" />
                        Offers
                    </Link>
                </Nav.Item> */}

                <Nav.Item>
                    <Link className="dash_sidebar_a nav-link" to="catelogue-page">
                        <FontAwesomeIcon icon={faGift} className="mr-2" />
                        Catalogue Page
                    </Link>
                </Nav.Item>
            </Nav>
        </div>
    );
};

export default SideBar;
